



















import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import { Fragment } from 'vue-fragment';

import FaqMixin from '@/mixins/faq';
import CommonMixin from '@/mixins/common';
import FaqSection from './FaqSection.vue';
import { ArticleData } from '@/model/faq';
import FullPageLoader from '@/components/loader/FullPageLoader.vue';

@Component({
  components: {
    Fragment,
    FaqSection,
    FullPageLoader
  }
})
export default class FaqMain extends Mixins(CommonMixin, FaqMixin) {
  @Prop({ default: null, required: false })
  idParam!: string | null;

  faqTitle = '자주 묻는 질문';
  categoryTitle = '유형별 문의';

  articlesByCategory: ArticleData[] = [];

  // Get the articles when they are finished loading.
  @Watch('search')
  @Watch('loading', { immediate: true, deep: true })
  updateArticles() {
    const id = this.search ? 'searched' : this.idParam;
    if (!this.isLoading(id)) {
      this.articlesByCategory = this.getArticlesByCategory(id);
    }
  }
}
